import React, { FC } from 'react';
import styled from 'styled-components';
import { WindowWidthContext } from '@minecraft.utils';
import { useTranslation } from '@blocs.i18n';
import { FilterValues } from '../../shared/types';
import { ClearButton } from '../../shared/styles';
import { FilterBasicFormContainer, FormFieldList, FilterBasicContentHeader, CloseIcon } from './FilterBasicFormStyles';
import FilterBasicFormListener from './FilterBasicFormListener';
import FilterBasicFormButtonGroup from './FilterBasicFormButtonGroup';

const StyledClearButton = styled(ClearButton)`
  margin: 0.5rem 0 1rem;
  align-self: flex-end;
`;

export type FilterBasicFormProps = {
  isClearButtonVisible: boolean;
  showFilterSettingsButton?: boolean;
  showAdvancedSearchButton?: boolean;
  showFilterButton?: boolean;
  withFilterDrawer: boolean;
  advancedSearchRoute?: string;
  toggleFilterSettingsModal: () => void;
  toggleFilterBasicOverlay: () => void;
  onClear: (filtersKeys?: string[]) => void;
  onRetainedFiltersChange: (newFilters: FilterValues) => void;
  onNavigateAdvancedSearchRoute?: () => void;
};

const FilterBasicForm: FC<FilterBasicFormProps> = ({
  isClearButtonVisible,
  showFilterSettingsButton,
  showAdvancedSearchButton,
  showFilterButton,
  withFilterDrawer,
  advancedSearchRoute,
  toggleFilterSettingsModal,
  toggleFilterBasicOverlay,
  onClear,
  onRetainedFiltersChange,
  children,
  onNavigateAdvancedSearchRoute,
}) => {
  const { t } = useTranslation();
  const { lessSm } = WindowWidthContext.useWidthData();

  return (
    <FilterBasicFormContainer $asOverlay={lessSm} data-testid="bloc-filter-basic-filter-container">
      {lessSm && (
        <FilterBasicContentHeader>
          <h3>{t('common:button.filter')}</h3>
          <CloseIcon inheritColor name="close" onClick={toggleFilterBasicOverlay} />
        </FilterBasicContentHeader>
      )}
      {isClearButtonVisible && (
        <StyledClearButton
          onClick={(): void => {
            onClear();
          }}
        >
          {t('common:button.clear')}
        </StyledClearButton>
      )}

      <FilterBasicFormListener onRetainedFiltersChange={onRetainedFiltersChange} />
      <FormFieldList>
        {children}
        <FilterBasicFormButtonGroup
          showFilterSettingsButton={showFilterSettingsButton}
          showAdvancedSearchButton={showAdvancedSearchButton}
          showFilterButton={showFilterButton}
          withFilterDrawer={withFilterDrawer}
          advancedSearchRoute={advancedSearchRoute}
          toggleFilterSettingsModal={toggleFilterSettingsModal}
          toggleFilterBasicOverlay={toggleFilterBasicOverlay}
          onNavigateAdvancedSearchRoute={onNavigateAdvancedSearchRoute}
        />
      </FormFieldList>
    </FilterBasicFormContainer>
  );
};

export default FilterBasicForm;
